import React, { useCallback, useMemo, useState } from "react";
import FilterIndicator from "./FilterIndicator";

export default function RenderAccordion({
  name = "",
  path = "",
  color = "white",
  className = "",
  children,
  itemsBelow = [],
  onSelectGroup = () => {},
  selected = [],
}) {
  const renderAsDetail = name.length > 0;
  const [isOpen, setIsOpen] = useState(false);

  // do we have a zero/partial/full selection of child filter items?
  const filterStatus = useMemo(() => {
    const s = new Set([...selected]);
    const difference = new Set([...itemsBelow].filter((x) => s.has(x)));

    return difference.size === itemsBelow.length
      ? "full"
      : difference.size === 0
      ? "zero"
      : "partial";
  }, [selected, itemsBelow]);

  const toggleDetail = useCallback(() => {
    setIsOpen((isOpen) => !isOpen);
  }, []);

  return renderAsDetail ? (
    <div className={`border-bottom ${className}`}>
      <div className="flex flex-row items-center my1  pointer">
        <div className="flex items-center mln1" onClick={toggleDetail}>
          <span className="" style={{ color: color }}>
            <svg
              className={`filter-group__indicator ${
                isOpen ? `filter-group__indicator--expanded` : ``
              }`}
              fill={color}
              role="img"
              aria-label="expand filter group"
            >
              <use xlinkHref="#chevron-down" />"
            </svg>
          </span>{" "}
          <span style={{ color }}>{name}</span>
        </div>
        <FilterIndicator
          color={color}
          className="ml1 pointer"
          status={filterStatus}
          width={15}
          onClick={onSelectGroup}
        />
      </div>
      {isOpen && children}
    </div>
  ) : (
    <>{children}</>
  );
}
